'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Container } from '@/components/container/container';
import { Button } from '@/components/ui/button/button';
import { Heading } from '@/components/ui/heading/heading';
import { useStaleChunkReload } from '@/utils/staleChunkReload';

/**
 * Last-resort boundary for /aukcje. The page itself already degrades gracefully
 * when the provider fails (FR-005), so reaching this means an unexpected render
 * error rather than a provider outage.
 */
export default function AuctionLotsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // A chunk the deploy removed: one full navigation to the same URL, no screen.
  const reloading = useStaleChunkReload(error);

  useEffect(() => {
    console.error('Auction lots error:', error);
  }, [error]);

  if (reloading) return null;

  return (
    <main className="min-h-screen flex items-center justify-center">
      <Container className="text-center">
        <Heading variant="h1" className="mb-4">
          Nie udało się załadować aukcji
        </Heading>
        <p className="text-neutral-400 mb-8 max-w-md mx-auto">
          Przepraszamy, wystąpił problem podczas ładowania listy aukcji. Spróbuj ponownie za chwilę.
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={reset} variant="primary">
            Spróbuj ponownie
          </Button>
          <Button as={Link} href="/kontakt" variant="secondary">
            Napisz do nas
          </Button>
        </div>
      </Container>
    </main>
  );
}
